<!-- ImprintSummary.vue - DEBUG format for development -->
<template>
  <div class="imprint-summary-debug">
    <div class="debug-header">
      <span class="debug-title">{{ title }}</span>
      <span class="debug-index">[Index: {{ imprintIndex }}]</span>
    </div>

    <div class="debug-content">
      <!-- Raw Data Structure -->
      <div class="debug-section">
        <div class="debug-label">Raw imprintData:</div>
        <pre class="debug-value">{{ JSON.stringify(imprintData, null, 2) }}</pre>
      </div>

      <!-- Location -->
      <div class="debug-section">
        <div class="debug-label">location <span class="type-badge">Object</span></div>
        <div class="debug-value">
          <div v-if="imprintData.location">
            sku: "{{ imprintData.location.sku }}" <span class="type-badge">string</span><br>
            title: "{{ imprintData.location.title }}" <span class="type-badge">string</span><br>
            imprintLines: {{ imprintData.location.imprintLines }} <span class="type-badge">number</span>
          </div>
          <div v-else class="null-value">null</div>
        </div>
      </div>

      <!-- Message Type -->
      <div class="debug-section">
        <div class="debug-label">messageType <span class="type-badge">string</span></div>
        <div class="debug-value">"{{ imprintData.messageType }}"</div>
      </div>

      <!-- Text Lines -->
      <div class="debug-section">
        <div class="debug-label">textLines <span class="type-badge">Array[{{ textLines.length }}]</span></div>
        <div class="debug-value">
          <div v-if="textLines.length > 0">
            <div v-for="(line, index) in textLines" :key="line.id" class="array-item">
              [{{ index }}] {<br>
              &nbsp;&nbsp;id: {{ line.id }} <span class="type-badge">number</span>,<br>
              &nbsp;&nbsp;type: "{{ line.type }}" <span class="type-badge">string</span>,<br>
              &nbsp;&nbsp;message: "{{ line.message }}" <span class="type-badge">string</span>,<br>
              &nbsp;&nbsp;selectedColor: "{{ line.selectedColor }}" <span class="type-badge">string</span>,<br>
              &nbsp;&nbsp;selectedColorObj: {{ line.selectedColorObj ? `{sku: "${line.selectedColorObj.sku}", desc: "${line.selectedColorObj.desc}"}` : 'null' }} <span class="type-badge">Object|null</span>,<br>
              &nbsp;&nbsp;customColor: {{ line.customColor }} <span class="type-badge">boolean</span><br>
              }
            </div>
          </div>
          <div v-else class="empty-array">[]</div>
        </div>
      </div>

      <!-- Image Data -->
      <div class="debug-section">
        <div class="debug-label">imageData <span class="type-badge">Object|null</span></div>
        <div class="debug-value">
          <div v-if="imprintData.imageData">
            {{ JSON.stringify(imprintData.imageData, null, 2) }}
          </div>
          <div v-else class="null-value">null</div>
        </div>
      </div>

      <!-- Special Instructions -->
      <div class="debug-section">
        <div class="debug-label">specialInstructions <span class="type-badge">string</span></div>
        <div class="debug-value">
          <div v-if="imprintData.specialInstructions">
            "{{ imprintData.specialInstructions }}"
          </div>
          <div v-else class="empty-value">""</div>
        </div>
      </div>

      <!-- Apply to All -->
      <div class="debug-section">
        <div class="debug-label">applyToAll <span class="type-badge">Object</span></div>
        <div class="debug-value">
          <div v-if="imprintData.applyToAll">
            {<br>
            &nbsp;&nbsp;active: {{ imprintData.applyToAll.active }} <span class="type-badge">boolean</span>,<br>
            &nbsp;&nbsp;sourceLineId: {{ imprintData.applyToAll.sourceLineId }} <span class="type-badge">number|null</span><br>
            }
          </div>
          <div v-else class="null-value">null</div>
        </div>
      </div>

      <!-- Validation Errors -->
      <div v-if="imprintData.errors && Object.keys(imprintData.errors).length > 0" class="debug-section error-section">
        <div class="debug-label">errors <span class="type-badge">Object</span></div>
        <div class="debug-value">
          <pre>{{ JSON.stringify(imprintData.errors, null, 2) }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImprintSummary',

  props: {
    title: {
      type: String,
      default: 'Imprint'
    },
    imprintData: {
      type: Object,
      required: true
    },
    imprintIndex: {
      type: Number,
      default: 0
    }
  },

  computed: {
    textLines() {
      return (this.imprintData.textLines || []).filter(line => line.type === 'message');
    }
  }
};
</script>

<style scoped lang="scss">
.imprint-summary-debug {
  background: #1e1e1e;
  border: 1px solid #3c3c3c;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #d4d4d4;
}

.debug-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #569cd6;
}

.debug-title {
  font-size: 14px;
  font-weight: 600;
  color: #569cd6;
}

.debug-index {
  font-size: 12px;
  color: #858585;
}

.debug-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.debug-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  background: #252526;
  border-radius: 3px;

  &.error-section {
    background: #3f1f1f;
    border-left: 3px solid #f48771;
  }
}

.debug-label {
  font-weight: 600;
  color: #9cdcfe;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.debug-value {
  padding-left: 16px;
  color: #ce9178;
  line-height: 1.6;
  word-break: break-all;
    text-align: justify;

  pre {
    margin: 0;
    padding: 8px;
    background: #1e1e1e;
    border-radius: 3px;
    overflow-x: auto;
    color: #d4d4d4;
  }
}

.type-badge {
  display: inline-block;
  padding: 2px 6px;
  background: #264f78;
  color: #4ec9b0;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.array-item {
  margin-bottom: 8px;
  padding: 8px;
  background: #1e1e1e;
  border-radius: 3px;
  color: #d4d4d4;
}

.null-value {
  color: #569cd6;
  font-style: italic;
}

.empty-value {
  color: #858585;
  font-style: italic;
}

.empty-array {
  color: #858585;
  font-style: italic;
}
</style>
